module.exports = "<svg fill=\"#838381\" viewBox=\"0 0 28 28\"><path d=\"M4.348 23.529a2.11 2.11 0 0 1-1.557-.663c-.435-.441-.653-.957-.653-1.547V6.681c0-.591.218-1.108.653-1.55a2.106 2.106 0 0 1 1.557-.664h6.725c.299 0 .584.059.857.177.273.119.511.28.713.482l1.379 1.376h9.63c.592 0 1.108.22 1.55.662.443.442.665.958.665 1.547V21.32c0 .59-.222 1.106-.664 1.547-.443.442-.96.663-1.55.663H4.348zm0-2.21h19.305V8.711h-10.55l-2.03-2.03H4.348v14.638z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/folder.svg
// module id = 301
// module chunks = 1